export interface Category {
  id: string;
  name: string;
  icon: string;
  desc: string;
  entryCount: number;
}

export const categories: Category[] = [
  {
    id: "star",
    name: "明星风波",
    icon: "ri-flashlight-line",
    desc: "聚焦艺人公开行程中的突发话题与现场讨论，梳理时间线与各方回应。",
    entryCount: 3,
  },
  {
    id: "creator",
    name: "网红观察",
    icon: "ri-live-line",
    desc: "记录短视频与直播领域的内容争议、带货细节与账号动态变化。",
    entryCount: 2,
  },
  {
    id: "archive",
    name: "艺人档案",
    icon: "ri-archive-line",
    desc: "以人物为线索整理出道经历、作品脉络与舆情变化轨迹。",
    entryCount: 1,
  },
  {
    id: "screen",
    name: "影视争议",
    icon: "ri-film-line",
    desc: "围绕剧集选角、番位、剧情改编与幕后花絮的讨论归档。",
    entryCount: 2,
  },
  {
    id: "brand",
    name: "代言翻车",
    icon: "ri-shopping-bag-line",
    desc: "整理品牌合作中的文案、物料与解约传闻相关话题。",
    entryCount: 1,
  },
  {
    id: "comeback",
    name: "复出与澄清",
    icon: "ri-restart-line",
    desc: "跟进沉寂期之后的复出动态与官方澄清说明的完整记录。",
    entryCount: 1,
  },
];